import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appSpotlightMenuInflatorContainer]',
  standalone: false
})
export class SpotlightMenuInflatorContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
